import React, { useContext } from "react";
import { BRAND_AIA } from "@config/siteConfig";
import { ApplicationContext } from "@context/ApplicationContext";
import PromoLogoAia from "@components/Icons/PromoLogoAia";
import TicketIcon from "@components/Icons/TicketIcon";

const RedemptionsPlaceholder = ({ props }) => {
    const { children, innerRef, innerProps, isSelected, selectProps } = props;
    const { whiteLabel } = useContext(ApplicationContext);

    return ( 
        <div 
            className="redemptions__placeholder-wrapper"
            ref={innerRef}
            id={innerProps.id}
            onMouseMove={innerProps.onMouseMove}
            onMouseOver={innerProps.onMouseOver}
            onClick={() => selectProps.handleMenuDropdown()}
            onTouchStart={innerProps.onTouchStart}
            onTouchMove={innerProps.onTouchMove}
            onFocus={innerProps.onFocus}
            role="option"
            aria-selected={isSelected}
            tabIndex={-1}
        >
            <div className="redemptions__placeholder-icon">
                {whiteLabel?.brand_code === BRAND_AIA 
                    ? (<PromoLogoAia /> )
                    : (<TicketIcon />)
                }
            </div>
            <div className="redemptions__placeholder-content">
                {children}
            </div>
        </div>
    );
};

export default RedemptionsPlaceholder;
